// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"ShopsButton_headerIcon__1hYQd","headerTextIcon":"ShopsButton_headerTextIcon__1atI3","shopsButton":"ShopsButton_shopsButton__1cd4m"};